import { Content, ContentType } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { IUserDataService, RemoteUserData, TagData } from "./IUserDataService";
import Sdk from "api.digitalpages.module.sdk.api";
import { ContentService } from "..";
import { EntityData, RemoteContentDetail, RemoteContentReference } from "../contents/IContentService";

export class UserDataServiceApi implements IUserDataService
{
    async TagsAvailable(): Promise<TagData[]> 
    {
        var url = `cms/v1.1/user/data/tags`;
        var response:any[] = await Sdk.Api.dynamic.bridge(url, null, "GET");
        var result:TagData[] = response.map(p=> this.ToTagData(p));

        return result;
    }

    async TagsSharedAvailable(): Promise<TagData[]> 
    {
        var url = `cms/v1.1/user/data/tags/shared`;
        var response:any[] = await Sdk.Api.dynamic.bridge(url, null, "GET");
        var result:TagData[] = response.filter(p=> p.tag.active_share).map(p=> this.ToTagData(p.tag));

        return result;
    }

    async TagSubscribe(uid:string) : Promise<TagData>
    {
        var url = `cms/v1.1/user/data/tag/uid/${uid}/clone`;
        return await Sdk.Api.dynamic.bridge(url, null, "POST");
        // var tagData = this.ToTagData(response.tag);

        // return tagData;
    }

    async TagCreate(item:TagData) : Promise<TagData>
    {
        var connector = Sdk.Api.authorization.activeProject.connectors
            .find((connector:any)=>connector.features
            .find((f:string)=> f === "IConnectorUserData") !== undefined);

        var url = `cms/v1.1/user/connector/uid/${connector.uid}/tag`;
        var response:any = await Sdk.Api.dynamic.bridge(url, { name:item.name }, "POST");
        var tagData = this.ToTagData(response);

        // if (item.contents)
        // {
        //     for (const content of item.contents) 
        //     {
        //         await this.InsertContentInTagt(content, tagData);
        //         if (!tagData.contents) tagData.contents=[];

        //         tagData.contents.push(content);
        //     }
        // }

        return tagData;
    }

    async TagUpdate(item:TagData) : Promise<TagData>
    {
        var url = `cms/v1.1/user/tag/uid/${item.uid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, { 
            name:item.name,
            active_share:item.shareEnabled
        }, "PUT")

        var tagData = this.ToTagData(response);
        return tagData;
    }

    async TagDelete(item:TagData) : Promise<TagData>
    {
        // console.log("ReadingListDelete", item)
        var url = `cms/v1.1/user/tag/uid/${item.uid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "DELETE");

        return item;
    }

    async TagDataFromContent(content: Content): Promise<TagData[]> 
    {
        return [];
    }

    async UserDataAvailableShared() : Promise<RemoteUserData[]>
    {
        var result:RemoteUserData[] = [];
        var page:number = 1;

        while(true)
        {
            var url = `cms/v1.1/user/data/shared?page=${page}`;
            var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");

            for(var data of response.result)
            {
                var userData =  this.ToUserData(data);
                result.push(userData);
            }

            if (!response.next_page_query) break;
            page++;
        }
        
        return result;
    }

    ///UserData

    async UserDataAvailable() : Promise<RemoteUserData[]>
    {
        var result:RemoteUserData[] = [];
        var page:number = 1;

        while(true)
        {
            var url = `cms/v1.1/user/data?page=${page}`;
            var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");

            for(var data of response.result)
            {
                var userData =  this.ToUserData(data);

                if (userData.contextType == "ManagedContent" && userData.targetType == "ManagedContent" && (userData.tags == undefined || userData.tags.length == 0))
                {
                    // try {
                    //     await this.RemoveUserData(userData);
                    // }
                    // catch(err) {
                    //     console.log(err)
                    // }
                }else{
                    result.push(userData);
                }
            }

            if (!response.next_page_query) break;
            page++;
        }
        
        return result;
    }

    async RemoveUserData(userData:RemoteUserData)
    {
        var url = `cms/v1.1/user/data/uid/${userData.uid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "DELETE");
    }

    async InsertContentInTagt(content:Content, tag:TagData) : Promise<RemoteUserData>
    {
        var url = `cms/v1.1/user/data?context_type=ManagedContent&target_type=ManagedContent&target_uid=${content.uid}&context_uid=${content.uid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");
        var contens:any[] = response.result;

        if (contens.length == 0)
        {
            var connector = Sdk.Api.authorization.activeProject.connectors
                .find((connector:any)=>connector.features
                .find((f:string)=> f == "IConnectorUserData") != undefined);
    
            var url = `cms/v1.1/user/connector/uid/${connector.uid}/data`;
    
            response = await Sdk.Api.dynamic.bridge(url, { 
                context_uid : content.uid, 
                context_type: 'ManagedContent',
                target_uid : content.uid, 
                target_type: 'ManagedContent',
                tags: [ { name: tag.name }]
            }, "POST")
        }else
        {
            var data = contens[0];
            var url = `cms/v1.1/user/data/uid/${data.uid}`;

            if (!data.tags) data.tags = [];

            var found = data.tags.find((p:any)=> p.name === tag.name);
            if (found) return this.ToUserData(data);

            data.tags.push({name:tag.name});
            response = await Sdk.Api.dynamic.bridge(url, data, "PUT");
        }

        return this.ToUserData(response);
    }

    async RemoveContentFromTag(content:Content, tag:TagData) : Promise<RemoteUserData[]>
    {
        var result:RemoteUserData[] = [];

        var url = `cms/v1.1/user/data?context_type=ManagedContent&target_type=ManagedContent&target_uid=${content.uid}&context_uid=${content.uid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");
        var contens:any[] = response.result;

        for (const content of contens) {
            if (!content.tags) content.tags =[];

            content.tags = content.tags.filter((p:any)=> p.uid != tag.uid);
            var url = `cms/v1.1/user/data/uid/${content.uid}`;

            response = await Sdk.Api.dynamic.bridge(url, content, "PUT");
            
            var data = this.ToUserData(response);
            result.push(data);
        }

        return result;
    }


    //////

    async ContentsFromTagData(content:TagData) : Promise<Content[]>
    {
        // console.log("FavoriteContents")
        var result:Content[] = [];
        var page:number = 1;

        while(true)
        {
            var url = `cms/v1.1/user/data?context_type=ManagedContent&target_type=ManagedContent&page=${page}&tag_uid=${content.uid}`;
            var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");
            var contens:any[] = response.result;

            page++;
            if (contens.length == 0) break;

            for (const content of contens) 
            {
                try
                {
                    var contentDetail = await ContentService.ContentDetail(content.context_uid);
                    result.push(contentDetail);
                }catch(e)
                {
                    // console.log(e);
                }

                
            }
        }

        return result;
    }

    ToTagData(data:any) : TagData
    {
        var result: TagData = {
            uid : data.uid,
            name : data.name,
            shareCode : data.code_share,
            shareEnabled : data.active_share
        }

        return result;
    }

    // Evaluate 
    async PostUserEvaluation(contentUid: string, rate: number): Promise<any> {
        const url = `cms/v1.1/evaluation/managedContent/uid/${contentUid}/score`
        const response = await Sdk.Api.dynamic.bridge(url, { note: rate }, 'POST')
    
        return response
      }
    async UpdateUserEvaluation(reviewUid: string, rate: number): Promise<any> {
        const url = `cms/v1.1/evaluation/uid/${reviewUid}`
        const response = await Sdk.Api.dynamic.bridge(url, { note: rate }, 'PUT')
    
        return response
      }

    async DeleteUserEvaluation(reviewUid: string): Promise<any> {
        const url = `cms/v1.1/evaluation/uid/${reviewUid}`
        const response = await Sdk.Api.dynamic.bridge(url, null, 'DELETE')
    
        return response
      }

    ///downloads


    async ContentDownload(contentReferenceUid:string) : Promise<boolean>
    {
        var url = `content/uid/${contentReferenceUid}/download`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "POST");

        return response.status;
    }

    async ContentDelete(contentReferenceUid:string) : Promise<boolean>
    {
        var url = `content/uid/${contentReferenceUid}`;
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "DELETE");

        return response.status;
    }

    async ContentDownloaded() : Promise<Array<RemoteContentDetail>>
    {
        var url = "contents/downloaded";
        var response:any = await Sdk.Api.dynamic.bridge(url, null, "GET");
        var result = this.ToContentReferences(response);

        return result
    }

    ToContentReferences(serverData:any) : RemoteContentDetail[]
    {
        var result: RemoteContentDetail[] = [];

        for (const reference of serverData) 
        {
            var rr = this.ToContentReference(reference);
            var rg = this.ToContent(reference.content_group);

            var existRg = result.find(p=> p.uid == rg.uid);

            if (!existRg)
            {
                result.push(rg);
                existRg = rg;
            }
            
            if (!existRg.references) existRg.references = [];
            existRg.references.push(rr);
        }

        return result;
    }

    ToContentReference(serverData:any) : RemoteContentReference
    {
        var format = ContentType.PDF;

        if (serverData.mime_type.indexOf("epub") != -1)
        {
            format = ContentType.PDF;
        }
        
        
        var reference:RemoteContentReference = {
            url : Sdk.Api.dynamic.bridgeUrl(`cms/v1.1/managed/content/reference/uid/${serverData.uid}/content`, null),
            downloadProgress:serverData.download_progress,
            mimeType: serverData.mime_type,
            uid : serverData.uid,
            format: format,
            products : [],
        };

        return reference;
    }

    ToContent(serverData:any) : RemoteContentDetail
    {
        var thumbUrl = Sdk.Api.dynamic.bridgeUrl(`cms/v1.1/managed/content/group/uid/${serverData.uid}/thumb`, null);
        var content:RemoteContentDetail = 
        {
            uid : serverData.uid,
            title : serverData.properties.find((p:any)=> p.name == "Nome")?.value,
            author : serverData.properties.find((p:any)=> p.name == "Autor")?.value,
            description : serverData.properties.find((p:any)=> p.name == "Descrição")?.value,
            readingTime : serverData.properties.find((p:any)=> p.name == "Tempo de leitura")?.value ?? "Tempo não estimado",
            image : serverData.image,
            entities : serverData.entities?.map((p:any)=> 
            {
                var result:EntityData =  {
                    uid : p.uid,
                    entityUid : p.entity_uid
                }

                return result;
            })
        }

        if (!content.image) content.image = thumbUrl;
        
        return content;
    }

    ToUserData(serverData:any) : RemoteUserData
    {
        var result: RemoteUserData = 
        {
            uid : serverData.uid,
            annotation: serverData.annotation,
            contextType: serverData.context_type,
            contextUid: serverData.context_uid,
            description: serverData.description,
            externalData: serverData.external_data,
            externalType: serverData.external_type,
            externalUid: serverData.external_uid,
            name: serverData.name,
            targetType : serverData.target_type,
            targetUid: serverData.target_uid,
            tags: serverData.tags?.map((t:any)=> this.ToTagData(t))
        }

        return result;
    }
}